import { render, staticRenderFns } from "./CouponDetail.vue?vue&type=template&id=4cbfea26"
import script from "./CouponDetail.vue?vue&type=script&lang=js"
export * from "./CouponDetail.vue?vue&type=script&lang=js"
import style0 from "./CouponDetail.vue?vue&type=style&index=0&id=4cbfea26&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports